import { useState } from 'react';
import { useAuth } from '../AuthProvider';
import { getWatchListDrivers, fetchRaceHistoryByDriver, formatRaceData } from './watchListApi';

export const useWatchList = () => {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  const [watchListListValue, setWatchListListValue] = useState("");
  const [watchListList, setWatchListList] = useState([]);
  const [criteriaId, setCriteriaId] = useState(null);
  const [raceHistoryData, setRaceHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGetWatchListDrivers = async () => {
    try {
      const data = await getWatchListDrivers(userId);
      setWatchListList(data);
    } catch (error) {
      console.error("Failed to get watchlist drivers:", error);
    }
  };

  const handleMyWatchListChange = async (e) => {
    const selectedName = e.target.value;
    setWatchListListValue(selectedName);
    const selectedItem = watchListList.find(item => item.name === selectedName);

    if (selectedItem) {
      setCriteriaId(selectedName);

      // Fetch race history based on type
      setLoading(true);
      try {
        let driverName = "";
        let carNumber = "";

        if (selectedItem.type === 'DRIVER') {
          driverName = selectedName;
        } else if (selectedItem.type === 'CAR_NO') {
          carNumber = selectedName;
        }

        const raceData = await fetchRaceHistoryByDriver(driverName, carNumber);
        const formattedData = formatRaceData(raceData);
        setRaceHistoryData(formattedData);
      } catch (error) {
        console.error("Failed to fetch race history:", error);
        setRaceHistoryData([]);
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    watchListListValue,
    setWatchListListValue,
    watchListList,
    criteriaId,
    raceHistoryData,
    loading,
    handleGetWatchListDrivers,
    handleMyWatchListChange
  };
};
